import { render } from "./ImagesField.vue?vue&type=template&id=b3e2f3a4"
import script from "./ImagesField.vue?vue&type=script&lang=js"
export * from "./ImagesField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__